import axios from "axios";

// const DEVICE_API_URL = process.env.REACT_APP_DEVICE_API_URL || "http://localhost:8000";
const DEVICE_API_URL = (window.location.protocol === "https:"? "https://" + window.location.host: "http://" + window.location.host);
const basicAuth = "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USER || "enfarm"}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD || "en13122022"}`);

const deviceApi = axios.create({
  baseURL: DEVICE_API_URL,
});

deviceApi.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['Authorization'] = basicAuth;
  return config;
});

export default deviceApi;